export default {
  getLanguage: (state) => state.language,
  getAuthIntent: (state) => state.authIntent
}
